<template>
  <b-modal
    id="updateVehicleModal"
    size="md"
    content-class="sub-menu-bg-blue-transparent uv-modal"
    title="Update Vehicle"
    hide-footer
    no-fade
    header-close-variant="light"
  >
    <div class="uv-body">

      <!-- Current vehicle banner -->
      <div class="uv-info-strip" v-if="originalName">
        <span class="uv-info-label">Editing</span>
        <span class="uv-info-value">{{ originalName }}</span>
      </div>

      <!-- Vehicle Name -->
      <div class="uv-field">
        <label class="uv-label">Vehicle Name</label>
        <b-form-input
          v-model="form.vehicle_name"
          placeholder="Enter vehicle name..."
          autocomplete="off"
        />
      </div>

      <!-- Region — single-select chips -->
      <div class="uv-field">
        <label class="uv-label">Region</label>
        <div class="uv-region-grid">
          <button
            v-for="r in regionOptions"
            :key="r.extent_id"
            type="button"
            class="uv-region-chip"
            :class="{ selected: form.region == r }"
            @click="form.region = r"
          >
            {{ r.region_name }}
          </button>
        </div>
      </div>

      <!-- Actions -->
      <div class="uv-actions">
        <b-button
          variant="primary"
          @click="submit()"
          :disabled="!isValid"
        >
          Save Changes
        </b-button>
      </div>

    </div>
  </b-modal>
</template>

<script>
import axios from 'axios'
export default {
  name: 'MMP_DPR_UpdateVehicle',
  props: ['vehicle', 'user'],
  data() {
    return {
      originalName: '',
      form: {
        vehicle_name: '',
        region: null
      },
      regionOptions: []
    }
  },
  computed: {
    isValid() {
      return this.form.vehicle_name.trim().length > 0 && !!this.form.region
    }
  },
  mounted() {
    this.getRegions();
  },
  methods: {
    submit() {
      if (!this.isValid) return
      if (sessionStorage.token) {
        axios.put(process.env.API_LOCATION + '/api/dpr/updateVehicle', {
          id: this.vehicle.id,
          vehicle_name: this.form.vehicle_name.trim(),
          region: this.form.region.extent_id,
          user: this.user.id
        }, {
          headers: { 'x-auth-token': sessionStorage.token }
        }).then(response => {
          const content = response.data
          if (content.errors) {
            this.$bvToast.toast(content.errors, {
              title: 'Update Vehicle Error',
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            })
          } else {
            this.$bvToast.toast('Vehicle updated successfully.', {
              title: 'Vehicle Updated',
              variant: 'success',
              autoHideDelay: 5000,
              toaster: 'b-toaster-top-right'
            })
            this.$emit('refresh')
            this.$bvModal.hide('updateVehicleModal')
          }
        }).catch(error => console.log(error))
      } else {
        console.log('No User Token')
      }
    },
    getRegions() {
      if (sessionStorage.token) {
        axios.get(process.env.API_LOCATION + '/api/dpr/getAcquisitionRegions', {
          headers: { 'x-auth-token': sessionStorage.token }
        }).then(response => {
          const content = response.data
          if (content.errors) {
            this.$bvToast.toast(content.errors, {
              title: 'Update Vehicle Error',
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            })
          } else {
            this.regionOptions = content.rows;
          }
        }).catch(error => console.log(error))
      } else {
        console.log('No User Token')
      }
    },
  },
  watch: {
    vehicle(newVal) {
      if (newVal) {
        this.originalName = newVal.vehicle_name
        this.form.vehicle_name = newVal.vehicle_name
        this.form.region = this.regionOptions.filter(region => region.region_name == newVal.region)[0]
      }
    }
  }
}
</script>

<style scoped>
.uv-body {
  padding: 4px 0 8px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Current vehicle banner */
.uv-info-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: rgba(6, 60, 109, 0.04);
  border: 1px solid rgba(6, 60, 109, 0.12);
  border-left: 3px solid #063c6d;
  border-radius: 6px;
  font-size: 13px;
}
.uv-info-label {
  color: rgba(6, 60, 109, 0.6);
  font-weight: 500;
}
.uv-info-value {
  color: #063c6d;
  font-weight: 600;
}

/* Form fields */
.uv-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.uv-label {
  font-size: 11px;
  font-weight: 600;
  color: rgba(6, 60, 109, 0.7);
  letter-spacing: 0.07em;
  text-transform: uppercase;
  margin: 0;
}

/* Region single-select chips */
.uv-region-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.uv-region-chip {
  padding: 5px 16px;
  border-radius: 20px;
  border: 1px solid rgba(6, 60, 109, 0.2);
  background: rgba(6, 60, 109, 0.04);
  color: rgba(6, 60, 109, 0.6);
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}
.uv-region-chip:hover {
  background: rgba(6, 60, 109, 0.08);
  color: #063c6d;
}
.uv-region-chip.selected {
  background: rgba(6, 60, 109, 0.1);
  border-color: #063c6d;
  color: #063c6d;
  font-weight: 600;
}

/* Actions */
.uv-actions {
  display: flex;
  justify-content: center;
  padding-top: 4px;
}
</style>

<style>
.uv-modal .form-control {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
}
.uv-modal .form-control:focus {
  background: #fff !important;
  border-color: #063c6d !important;
  box-shadow: 0 0 0 2px rgba(6, 60, 109, 0.12) !important;
}
</style>
